export const STORAGE_KEY = "sac_step2_data";
export const STORAGE_STEP5 = "sac_step5_data";

export const step2Styles = {
  width: "100%",
  boxSizing: "border-box",
  "& .step2-loading": {
    height: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "12px",
  },
  "& .step2-title": {
    color: "#8f8f8f",
    fontWeight: 500,
    letterSpacing: "0.2px",
    textAlign: "left",
    marginBottom: "18px",
  },
  "& .step2-filter-label": {
    color: "#7f7f7f",
    fontWeight: 600,
  },
  "& .step2-select.MuiInputBase-root, & .step2-select .MuiOutlinedInput-root": {
    borderRadius: "999px",
    background: "#fff",
  },
  "& .step2-select .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d6d6d6",
  },
  "& .step2-select:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#00c7db",
  },
  "& .step2-select.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#00c7db",
    borderWidth: "2px",
  },
  "& .step2-select .MuiSelect-select": {
    minHeight: "44px",
    padding: "10px 44px 10px 18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "#7f7f7f",
    fontWeight: 600,
  },
  "& .step2-table.MuiPaper-root": {
    border: "1px solid #d6d6d6",
    borderRadius: "6px",
    boxShadow: "none",
    overflow: "auto",
  },
  "& .step2-table-inner": {
    minWidth: "900px",
  },
  "& .step2-thead .step2-th.MuiTableCell-root, & .step2-table .MuiTableCell-head": {
    background: "#9f9f9f",
    color: "#ffffff",
    fontWeight: 700,
    borderBottom: "1px solid #d6d6d6",
    padding: "10px 12px",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  },
  "& .step2-th-check": {
    width: "140px",
    textAlign: "center",
  },
  "& .step2-th-actions": {
    width: "180px",
    textAlign: "center",
  },
  "& .step2-td.MuiTableCell-root, & .step2-table .MuiTableCell-body": {
    color: "#6f6f6f",
    borderBottom: "1px solid #ececec",
    padding: "14px 12px",
    verticalAlign: "middle",
    fontSize: "13px",
    lineHeight: 1.35,
  },
  "& .step2-td-check": {
    textAlign: "center",
    width: "140px",
  },
  "& .step2-td-actions": {
    textAlign: "center",
    width: "180px",
  },
  "& .step2-td-text": {
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  "& .step2-checkbox.MuiCheckbox-root": {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .step2-checkbox.MuiCheckbox-root .PrivateSwitchBase-input": {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    margin: 0,
    cursor: "pointer",
  },
  "& .step2-checkbox.MuiCheckbox-root .MuiSvgIcon-root, & .step2-checkbox.MuiCheckbox-root svg, & .step2-checkbox.MuiCheckbox-root path": {
    pointerEvents: "none",
  },
  "& .step2-checkbox.MuiCheckbox-root.Mui-checked": {
    color: "#00c7db",
  },
  "& .step2-checkbox.MuiCheckbox-root.Mui-disabled": {
    color: "#e0e0e0",
  },
  "& .step2-btn.MuiButton-root": {
    borderRadius: "999px",
    height: "44px",
    minWidth: "180px",
    padding: "0 22px",
    fontWeight: 800,
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    boxShadow: "none",
  },
  "& .step2-btn-back.MuiButton-outlined": {
    border: "2px solid #00c7db",
    color: "#00c7db",
    background: "transparent",
  },
  "& .step2-btn-back.MuiButton-outlined:hover": {
    borderColor: "#00a9b9",
    color: "#00a9b9",
    background: "rgba(0, 199, 219, 0.08)",
  },
  "& .step2-btn-next.MuiButton-contained": {
    background: "#00c7db",
    color: "#ffffff",
  },
  "& .step2-btn-next.MuiButton-contained:hover": {
    background: "#00a9b9",
  },
  "& .step2-btn.Mui-disabled": {
    opacity: 0.6,
  },
  "& .step2-btn-inline.MuiButton-root": {
    minWidth: "150px",
    height: "36px",
    padding: "0 18px",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.5px",
  },
  "@media (max-width:600px)": {
    "& .step2-title": {
      fontSize: "28px",
    },
    "& .step2-actions": {
      flexDirection: "column",
      alignItems: "stretch",
    },
    "& .step2-btn.MuiButton-root, & .step2-select.MuiInputBase-root": {
      width: "100%",
      minWidth: "100%",
    },
  },
};
